module.exports = __webpack_public_path__ + "img/stick_divers_services.a44d1e5f.svg";